import { axiosInstance } from '@configs/axios/axiosInstance';

import type { Instructor } from '../types/instructor.types';
import type {
  GetInstructorsRequest,
  GetInstructorsResult,
} from './getInstructors.types';

/**
 * Fetch available instructors for current user
 * Endpoint: GET /instructors
 *
 * `customerId` is sent as a request header.
 * Filter params are sent as query parameters.
 * Total count is returned via the `x-total-count` response header.
 */
export async function getInstructors(
  customerId: string,
  params?: GetInstructorsRequest | undefined
): Promise<GetInstructorsResult> {
  const response = await axiosInstance.get<Instructor[]>('/instructors', {
    headers: {
      'X-Customer-Id': customerId,
    },
    params,
  });

  const total = Number(response.headers['x-total-count']) || 0;

  return {
    elements: response.data,
    total,
  };
}
